import { Item } from 'devextreme-react/tab-panel';
import { NumericFormat } from 'react-number-format';
import { PhoneInput } from '../../../common/SharedComponents';
import { StateSelect, ZipCodeInput } from '../../../common/SharedComponents';

interface IDetailsTabParameters {
    principalId: number;
    entityId: number;
    entityName: string;
    firstName: string;
    set_firstName: React.Dispatch<React.SetStateAction<string>>;
    middleName: string;
    set_middleName: React.Dispatch<React.SetStateAction<string>>;
    lastName: string;
    set_lastName: React.Dispatch<React.SetStateAction<string>>;
    suffix: string;
    set_suffix: React.Dispatch<React.SetStateAction<string>>;
    street1: string;
    set_street1: React.Dispatch<React.SetStateAction<string>>;
    street2: string;
    set_street2: React.Dispatch<React.SetStateAction<string>>;
    city: string;
    set_city: React.Dispatch<React.SetStateAction<string>>;
    state: string;
    set_state: React.Dispatch<React.SetStateAction<string>>;
    zipCode: string;
    set_zipcode: React.Dispatch<React.SetStateAction<string>>;
    workPhone: string;
    set_workPhone: React.Dispatch<React.SetStateAction<string>>;
    mobilePhone: string;
    set_mobilePhone: React.Dispatch<React.SetStateAction<string>>;
    email: string;
    set_email: React.Dispatch<React.SetStateAction<string>>;
    secondaryEmail: string;
    set_secondaryEmail: React.Dispatch<React.SetStateAction<string>>;
    userResponsibleId: string;
    set_userResponsibleId: React.Dispatch<React.SetStateAction<string>>;
    netWorth: number | undefined;
    set_netWorth: React.Dispatch<React.SetStateAction<number | undefined>>;
    adjustedNetWorth: number | undefined;
    set_adjustedNetWorth: React.Dispatch<React.SetStateAction<number | undefined>>;
    percentOwnership: number | undefined;
    set_percentOwnership: React.Dispatch<React.SetStateAction<number | undefined>>;
    linkTitle: string;
    set_linkTitle: React.Dispatch<React.SetStateAction<string>>;
    isOfficer: boolean;
    set_isOfficer: React.Dispatch<React.SetStateAction<boolean>>;
    employees: [{ key: string; name: string }];
}

export const DetailsTab: React.FC<IDetailsTabParameters> = ({
    principalId,
    entityId,
    entityName,
    firstName,
    set_firstName,
    middleName,
    set_middleName,
    lastName,
    set_lastName,
    suffix,
    set_suffix,
    street1,
    set_street1,
    street2,
    set_street2,
    city,
    set_city,
    state,
    set_state,
    zipCode,
    set_zipcode,
    workPhone,
    set_workPhone,
    mobilePhone,
    set_mobilePhone,
    email,
    set_email,
    secondaryEmail,
    set_secondaryEmail,
    userResponsibleId,
    set_userResponsibleId,
    netWorth,
    set_netWorth,
    adjustedNetWorth,
    set_adjustedNetWorth,
    percentOwnership,
    set_percentOwnership,
    linkTitle,
    set_linkTitle,
    isOfficer,
    set_isOfficer,
    employees,
}) => {
    return (
        <Item
            title='Details'
            icon='home'
        >
            <div
                className='standard-form'
                style={{
                    padding: '0 10px 0 10px',
                }}
            >
                <h2 className='decorated sectionHeader'>Name</h2>
                <div className='row'>
                    <div className='columns small-12 large-4 formColumn'>
                        <label htmlFor='firstName'>
                            First Name
                            <span className='req'>*</span>
                        </label>
                        <input
                            type='text'
                            id='firstName'
                            name='firstName'
                            value={firstName}
                            // selected={firstName}
                            onChange={(e) => set_firstName(e.target.value)}
                            required={true}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 large-2 formColumn'>
                        <label htmlFor='middleName'>Middle</label>
                        <input
                            type='text'
                            id='middleName'
                            name='middleName'
                            value={middleName}
                            // selected={middleName}
                            onChange={(e) => set_middleName(e.target.value)}
                            required={false}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 large-4 formColumn'>
                        <label htmlFor='lastName'>
                            Last Name
                            <span className='req'>*</span>
                        </label>
                        <input
                            type='text'
                            id='lastName'
                            name='lastName'
                            value={lastName}
                            // selected={lastName}
                            onChange={(e) => set_lastName(e.target.value)}
                            required={true}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 large-2 formColumn'>
                        <label htmlFor='suffix'>Suffix</label>
                        <input
                            type='text'
                            id='suffix'
                            name='suffix'
                            value={suffix}
                            // selected={suffix}
                            placeholder='Jr, III etc'
                            onChange={(e) => set_suffix(e.target.value)}
                            required={false}
                            maxLength={20}
                        />
                    </div>
                </div>

                <h2 className='decorated sectionHeader'>Contact Details</h2>
                <div className='row'>
                    <div className='columns small-12 large-6 formColumn'>
                        <label htmlFor='street1'>
                            Street Address <span className='req'>*</span>
                        </label>
                        <input
                            id='street1'
                            name='street1'
                            type='text'
                            value={street1}
                            onChange={(event) => set_street1(event.target.value)}
                            required={true}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 large-6 formColumn'>
                        <label htmlFor='street2'>Street Address 2</label>
                        <input
                            id='street2'
                            name='street2'
                            type='text'
                            value={street2}
                            onChange={(event) => set_street2(event.target.value)}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 large-6 formColumn'>
                        <label htmlFor='city'>
                            City <span className='req'>*</span>
                        </label>
                        <input
                            id='city'
                            name='city'
                            type='text'
                            value={city}
                            onChange={(event) => set_city(event.target.value)}
                            required={true}
                            maxLength={50}
                        />
                    </div>
                    <div className='columns small-12 medium-6 large-3 formColumn'>
                        <label htmlFor='state'>
                            State <span className='req'>*</span>
                        </label>
                        <StateSelect
                            id='state'
                            value={state}
                            onChange={(event) => set_state(event.target.value)}
                            required={true}
                        />
                    </div>
                    <div className='columns small-12 medium-6 large-3 formColumn'>
                        <label htmlFor='zipCode'>
                            Zip Code <span className='req'>*</span>
                        </label>
                        <ZipCodeInput
                            id='zipCode'
                            value={zipCode}
                            onChange={(event) => set_zipcode(event.target.value)}
                            required={true}
                            // maxLength={10}
                        />
                    </div>
                    <div className='columns small-7 medium-8 large-3 formColumn'>
                        <label htmlFor='workPhone'>
                            Work Phone <span className='req'>*</span>
                        </label>
                        <PhoneInput
                            id='workPhone'
                            value={workPhone}
                            onChange={(value) => set_workPhone(value)}
                            required={true}
                        />
                    </div>
                    <div className='columns small-7 medium-8 large-3 formColumn'>
                        <label htmlFor='mobilePhone'>
                            Mobile Phone <span className='req'>*</span>
                        </label>
                        <PhoneInput
                            id='mobilePhone'
                            value={mobilePhone}
                            onChange={(value) => set_mobilePhone(value)}
                            required={true}
                        />
                    </div>
                    <div className='columns small-12 formColumn'>
                        <label htmlFor='email'>
                            Email <span className='req'>*</span> (also used as Login for the account)
                        </label>
                        <input
                            id='email'
                            name='email'
                            type='email'
                            value={email}
                            onChange={(event) => set_email(event.target.value)}
                            required={true}
                            maxLength={320}
                        />
                        {principalId > 0 && (
                            <div
                                style={{
                                    color: 'darkred',
                                }}
                            >
                                * Changing this will also change the login for the account!
                            </div>
                        )}
                    </div>

                    <div className='columns small-12 formColumn'>
                        <label htmlFor='secondaryEmail'>Secondary Email</label>
                        <input
                            id='secondaryEmail'
                            name='secondaryEmail'
                            type='email'
                            value={secondaryEmail}
                            onChange={(event) => set_secondaryEmail(event.target.value)}
                            required={false}
                            maxLength={320}
                        />
                    </div>
                </div>
                <h2 className='decorated sectionHeader'>BFI Information</h2>
                <div className='row'>
                    <div className='columns small-12 large-5 formColumn'>
                        <label htmlFor='bfipocId'>POC</label>
                        <select
                            id='userResponsibleId'
                            value={userResponsibleId}
                            onChange={(event) => set_userResponsibleId(event.target.value)}
                        >
                            <option
                                key=''
                                value=''
                            ></option>
                            {employees &&
                                employees.map((poc) => {
                                    return (
                                        <option
                                            key={poc.key}
                                            value={poc.key}
                                        >
                                            {poc.name}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>
                <h2 className='decorated sectionHeader'>Financials</h2>
                <div
                    className='row'
                    style={{
                        marginBottom: '10px',
                    }}
                >
                    <div className='columns small-12 large-2 formColumn'>
                        <label htmlFor='netWorth'>Net Worth</label>
                        <NumericFormat
                            thousandSeparator=','
                            prefix='$'
                            id='netWorth'
                            placeholder='$'
                            value={netWorth}
                            decimalScale={0}
                            allowNegative={true}
                            onValueChange={(values) => {
                                set_netWorth(values.floatValue);
                            }}
                            required={false}
                            className={(netWorth ?? 0 < 0) ? 'red' : ''}
                        />
                    </div>
                    <div className='columns small-12 large-2 formColumn'>
                        <label htmlFor='adjustedNetWorth'>Adjusted</label>
                        <NumericFormat
                            thousandSeparator=','
                            prefix='$'
                            id='adjustedNetWorth'
                            placeholder='$'
                            value={adjustedNetWorth}
                            decimalScale={0}
                            allowNegative={true}
                            onValueChange={(values) => {
                                set_adjustedNetWorth(values.floatValue);
                            }}
                            required={false}
                            className={(adjustedNetWorth ?? 0 < 0) ? 'red' : ''}
                        />
                    </div>
                </div>
                {entityId > 0 && (
                    <>
                        <h2 className='decorated'>Relationship to '{entityName}'</h2>
                        <div className='row'>
                            <div className='columns small-12 large-2 formColumn'>
                                <label htmlFor='percentOwnership'>Ownership %</label>
                                <NumericFormat
                                    thousandSeparator=','
                                    suffix='%'
                                    id='percentOwnership'
                                    value={percentOwnership ?? ''}
                                    decimalScale={2}
                                    allowNegative={false}
                                    onValueChange={(values) => {
                                        set_percentOwnership(values.floatValue);
                                    }}
                                    required={false}
                                    isAllowed={(values) => {
                                        const value = values?.floatValue;
                                        return value === undefined || value === null || (value >= 0 && value <= 100);
                                    }}
                                />
                            </div>
                            <div className='columns small-12 large-6formColumn'>
                                <label htmlFor='title'>Title</label>
                                <input
                                    id='title'
                                    name='title'
                                    type='text'
                                    value={linkTitle}
                                    onChange={(e) => set_linkTitle(e.target.value)}
                                    maxLength={50}
                                />
                            </div>
                            <div className='columns small-12 large-3 isOfficer'>
                                <input
                                    id='isOfficer'
                                    name='isOfficer'
                                    type='checkbox'
                                    checked={!!isOfficer}
                                    onChange={(e) => set_isOfficer(e.target.checked)}
                                />{' '}
                                Is Officer?
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Item>
    );
};
